import React, { useState, useEffect } from 'react';
import './LandingPage.css';
import api from '../utils/api';

function LandingPage({ onLoginClick }) {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchText();
    // Refresh text every 5 seconds to show updates
    const interval = setInterval(fetchText, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchText = async () => {
    try {
      const response = await api.get('/text');
      setText(response.data.content);
      setError('');
    } catch (error) {
      console.error('Error fetching text:', error);
      setError('Unable to load text');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-container">
        <div className="landing-header">
          <h1>Proof of concept</h1>
          <button onClick={onLoginClick} className="login-button">
            Login
          </button>
        </div>

        <div className="landing-content">
          <h2>Welcome</h2>
          <div className="text-display-section">
            <h3>Current Message</h3>
            {loading ? (
              <div className="loading-text">Loading...</div>
            ) : error ? (
              <div className="error-text">{error}</div>
            ) : (
              <div className="displayed-text">{text || 'Hello World'}</div>
            )}
          </div>
          <p className="info-text">
            This text can be updated by authenticated users. Click Login to manage the content.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;

